/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 3,
    spaceBetween: 32,
    breakpoints: {
      // when window width is <= 768px (tablet & mobile)
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      // when window width is >= 769px (desktop)
      769: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    },
    navigation: {
      nextEl: ".custom-next",
      prevEl: ".custom-prev",
    },
  });

   window.addEventListener('scroll', function(e) {
    e.preventDefault();

      // console.log("e Target",e.target);
      const header = document.querySelector('.header__wrapper'); 
      const headerHeight = document.querySelector('header').offsetHeight;
      const banners = document.querySelectorAll('.hero__wrapper'); 

     
      
      let isTransparent = false;  
      let lastBannerIndex = banners.length - 1;  

      // Loop through all the banners
      banners.forEach(function(banner, index) {
          const bannerBottom = banner.getBoundingClientRect().bottom;
          const bannerTop = banner.getBoundingClientRect().top;
          
          const previousBanner = banners[index - 1]; 
          const previousBannerBottom = previousBanner ? previousBanner.getBoundingClientRect().bottom : null;

          if (previousBannerBottom <= headerHeight && bannerTop > 0) {
              isTransparent = false; 
          }


          if (bannerTop <= headerHeight) {
              isTransparent = true;  
          }

          if (index === lastBannerIndex && bannerBottom <= headerHeight) {
              isTransparent = false; 
          }
      });

      if (isTransparent) {
          header.classList.add('transparent');
          header.classList.remove('js__header__stuck');
          document.body.classList.add(".has-first-section-overlay-header");
      } else {
          header.classList.remove('transparent');
          header.classList.add('js__header__stuck');
          document.body.classList.remove(".has-first-section-overlay-header");
      }
  });
});

$(document).ready(function(){
 
  console.log("its ready");
   setTimeout(()=>{
    if( $(".product__selectors .radio__button").length > 1){
        $(".product__selectors .radio__button").removeClass("hidden");
    }
       let params = new URLSearchParams(window.location.search);
       let variantId = params.get("variant");
        if (variantId) {
            console.log("Variant ID:", variantId);
            $(".product__subheading .variants_id").find(".sizes").each(function(index,ele){
              if($(ele).attr("var_id") == variantId ){
                  size_text = $(ele).html();
                  $(".multivariant_size").html(size_text);
                  console.log($(ele).attr("var_id"));

              }
                

            })
        }
        // else{
        //     $(".product__subheading .variants_id").find(".sizes").each(function(index,ele){
        //       if(index == 0 ){
        //           size_text = $(ele).html();
        //           $(".multivariant_size").html(size_text);
        //           console.log($(ele).attr("var_id"));

        //       }
        //     })
        // }
   },300)
   
})
setTimeout(()=>{
    if($(".product__selectors .radio__button").length > 1){
        $(".product__selectors .radio__button").removeClass("hidden");
    }

    
    let $checkedInput = $(".product__selectors input[type='radio']:checked");
    if($checkedInput.length){
        $checkedInput.trigger("change");
    }

    let params = new URLSearchParams(window.location.search);
    let variantId = params.get("variant");
    
    if(variantId){
        $(".product__subheading .variants_id").find(".sizes").each(function(index, ele){
            if($(ele).attr("var_id") == variantId){
                size_text = $(ele).html();
                $(".multivariant_size").html(size_text);
            }
        });
    } else {
       
        $(".product__subheading .variants_id").find(".sizes").each(function(index, ele){
            if(index == 0){
                size_text = $(ele).html();
                $(".multivariant_size").html(size_text);
            }
        });
    }
}, 300)

$(document).on("click", ".radio__button", function(e) {

    console.log($(".variant_options").length);
    if ($(".variant_options").length == 1 || $(".variant_options").length == 0) {
        return;
    }
    console.log("here it is");
    // ensure radio select ho jaye
    let $label = $(this).closest(".variant_options");
    let $input = $label.find("input[type='radio']");
    if ($input.length) {
        $input.prop("checked", true).trigger("change");
    }

    // wait for URL update
    let checkVariant = setInterval(function() {
        let params = new URLSearchParams(window.location.search);
        let variantId = params.get("variant");

        if (variantId) {
            console.log("Variant ID:", variantId);
            $(".product__subheading .variants_id").find(".sizes").each(function(index,ele){
              if($(ele).attr("var_id") == variantId ){
                  size_text = $(ele).html();
                  $(".multivariant_size").html(size_text);
                  console.log($(ele).attr("var_id"));

              }
                

            })
            clearInterval(checkVariant);
        }
       else{
            $(".product__subheading .variants_id").find(".sizes").each(function(index,ele){
              if(index == 0 ){
                  size_text = $(ele).html();
                  $(".multivariant_size").html(size_text);
                  console.log($(ele).attr("var_id"));

              }
            })
        }
    }, 50);

   
    setTimeout(() => clearInterval(checkVariant), 2000);
});

